import React from 'react';
import Stat from './stat';

function Stats() {
  return (
    <div className="stats flex">
      <div className="w-auto pl-[40px] pr-[40px] sm:pr-[120px] md:px-[100px] md:pl-[100px] md:pr-[120px] py-[100px] md:py-[160px] box-border">
        <h2 className="text-[9vw] sm:text-[48px] mb-20">NAIOSW by the Numbers</h2>
        <div className="flex flex-wrap max-w-[520px] sm:gap-4 gap-8 justify-start">
          <Stat number="145" description="GRADUATES" />
          <Stat number="5" description="INSTRUCTORS" />
          <Stat number="18" description="YEARS OF EXCELLENCE" />
          <Stat
            number="92"
            description="% CERTIFICATION SUCCESS RATE"
          />
          <Stat
            number="175"
            description="YEARS OF INSTRUCTOR EXPERIENCE"
          />
        </div>
      </div>
      <div className="stats_bg bg-cover h-auto flex-1 bg-no-repeat"></div>
    </div>
  );
}

export default Stats;
